import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Assistant = ({pathname, portfolioList, theme}) => {
  const assistantIframeRef = useRef(null);

  useEffect(() => {
    const ASSISTANT_ORIGIN = process.env.REACT_APP_ADVISOR_ASSISTANT_URL;

    const handleMessage = (event) => {
      if (event.origin !== ASSISTANT_ORIGIN) return;
      if (!event.data || event.data.type !== 'ADVISOR_ASSISTANT_READY') return;
      if (!assistantIframeRef.current) return;

      assistantIframeRef.current.contentWindow.postMessage(
        {
          type: 'ADVISOR_ASSISTANT_AUTH',
          username: process.env.REACT_APP_ADVISOR_ASSISTANT_USERNAME,
          password: process.env.REACT_APP_ADVISOR_ASSISTANT_PASSWORD,
        },
        ASSISTANT_ORIGIN
      );
    };
    

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const assistentQuery = useMemo( () => {
    const baseUrl = process.env.REACT_APP_ADVISOR_ASSISTANT_URL;
    const query = new URLSearchParams();
    query.set('iFrame', true);
    const themeIF = theme === 'dark-theme' ? 'dark' : 'light';
    query.set('theme', themeIF);
    const pathArray = pathname.split('/');
    const isAccount = pathArray.indexOf('accounts');
    const accountId = isAccount !== -1 && isAccount < pathArray.length - 1 ? pathArray[isAccount + 1] : null;
    const isPortfolio = pathArray.indexOf('portfolio');
    const portfolioId = isPortfolio !== -1 && isPortfolio < pathArray.length - 1 ? pathArray[isPortfolio + 1] : null;
    if (isAccount !== -1 && !isNaN(+accountId)) {
      query.set('client_id', accountId);
    }
    if (isPortfolio !== -1 && !isNaN(+portfolioId)) {
      const externalPortfolio = portfolioList?.find(portfolio => portfolio.id === +portfolioId)?.external_id;
      externalPortfolio && query.set('portfolio_id', externalPortfolio);
    }
    return `${baseUrl}?${query.toString()}`;

  }, [pathname, portfolioList, theme]);

  return (
    <div className="assistant-page-container">
      <iframe
        ref={assistantIframeRef}
        src={assistentQuery}
        width="100%"
        height="100%"
        frameBorder="0"
      />
    </div>
  );
};

export default Assistant;

Assistant.propTypes = {
  pathname: PropTypes.string.isRequired,
  portfolioList: PropTypes.array.isRequired,
  theme: PropTypes.string.isRequired,
};